import React from 'react'
import VideoCover from 'react-video-cover'

export default props => <VideoCover videoOptions={props} />



// WEBPACK FOOTER //
// ./src/ui/components/generic/FillVideo.js